<form DraggableDialog [formGroup]="form" (ngSubmit)="submit()">
  <div style="height:60px">
    <span mat-dialog-title class="title">Nytt schema</span>
  </div>
  <mat-dialog-content>
    <div class="input-row-group">

      <mat-form-field floatLabel="always">
        <mat-label>Uppdrag</mat-label>
        <mat-select placeholder="Uppdrag" [formControl]="typesFormControl">
          <mat-select-trigger>
            {{typesFormControl.value.name}}
          </mat-select-trigger>
          <mat-option *ngFor="let assignmentType of assignmentTypes" [value]="assignmentType">{{assignmentType.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>Förare</mat-label>
        <input type="text"
               placeholder="Förare"
               aria-label="Number"
               matInput
               [formControl]="driversFormControl"
               [matAutocomplete]="auto">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let userMapping of filteredUserMappings | async" [value]="userMapping" [ngStyle]="{ 'background-color': getDriverBackgroundColor(userMapping) }">
            {{userMapping.name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="input-row-group">
      <mat-form-field floatLabel="always">
        <mat-label>Från</mat-label>
        <mat-select placeholder="Från" [formControl]="fromFormControl" (selectionChange)="toChanged($event)">
          <mat-select-trigger>
            {{fromFormControl.value}}
          </mat-select-trigger>
          <mat-option *ngFor="let time of timeListFrom" [value]="time">{{time}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field floatLabel="always" style="width:3%">
        <mat-label>Till</mat-label>
        <mat-select placeholder="Till" [formControl]="toFormControl" (selectionChange)="toChanged($event)">
          <mat-select-trigger>
            {{toFormControl.value}}
          </mat-select-trigger>
          <mat-option *ngFor="let time of timeListTo" [value]="time">{{time}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="error-message" *ngIf="form.hasError('invalidRange')">
      Arbetspasset måste vara längre än 0 minuter.
    </div>

    <div class="error-message" *ngIf="form.hasError('moreThan24hrs')">
      Arbetspasset kan inte vara 24 timmar.
    </div>

    <div class="input-row-group">
      <mat-form-field floatLabel="always">
        <mat-label>Buss</mat-label>
        <mat-select placeholder="Buss" [formControl]="bussesFormControl">
          <mat-select-trigger>
            {{bussesFormControl.value?.number}}
          </mat-select-trigger>
          <mat-option *ngFor="let bus of buses" [value]="bus">{{bus.number}}{{bus.willCauseOverlap == true ? " Redan bokad" : ""}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>Anteckning</mat-label>
        <input type="text" matInput placeholder="Anteckning" formControlName="note">
      </mat-form-field>
    </div>

    <div class="input-row-group">
      <mat-form-field floatLabel="always">
        <mat-label>Aktivitet</mat-label>
        <input type="text" matInput placeholder="Aktivitet" formControlName="activityName">
      </mat-form-field>
    </div>

  </mat-dialog-content>
  <div style="border-bottom: 2px solid #0F1A41; width: 100%; margin-left:2px; margin-bottom: 20px; margin-top: 10px;"></div>
  <div style="display: flex;flex-direction:row-reverse;margin-bottom:15px">
    <button [ngClass]="{'disabled':!canSave()}" mat-flat-button type="submit" style="margin-left: 10px; background: #0F1A41; color: #FFFFFF; width:300px " [disabled]="!canSave()">
      Spara 
    </button>
    <button mat-button type="button" mat-dialog-close style="background:transparent;border-color:grey;color:grey;border-style:solid;border-width:1px; width:150px;">
      Avbryt
    </button>
  </div>
</form>
